import { combineReducers } from 'redux'
import localizedReducer from './localized/reducers'
import progressReducer from './progress/reducers'
import serverReducer from './serverNames/reducers'
import steamReducer from './steam/reducers'
import versionsReducer from './versions/reducers'

const reducer = combineReducers({
    localized: localizedReducer,
    progress: progressReducer,
    serverNames: serverReducer,
    steam: steamReducer,
    versions: versionsReducer,
})

export default reducer



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/reducers.js